// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"Loader_loaderOverlay__SQEnL","loader":"Loader_loader__Iv4Mh","spin":"Loader_spin__I0Tfd"};